module.exports = __webpack_public_path__ + "static/media/quick.bcebd3c8.png";